module.exports = __webpack_public_path__ + "static/img/230155_1_C_20240618_LC.92447c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/230155_1_C_20240618_LC.png
// module id = 84oi
// module chunks = 0